<template>
    <StandardPartsCatalog></StandardPartsCatalog>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const StandardPartsCatalog = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/StandardPartsCatalog/StandardPartsCatalog.vue"
    )
);

export default {
    name: "Project_StandardPartsCatalog",
    components: { StandardPartsCatalog, AuthLayout },
};
</script>
